import { render, staticRenderFns } from "./detaydialog.vue?vue&type=template&id=182e17ec"
import script from "./detaydialog.vue?vue&type=script&lang=js"
export * from "./detaydialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports